import React, { Component } from 'react'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../request'
import { Button, Card, Col, Icon, Input, List, notification, Popconfirm, Row, Select, Tooltip, Upload } from 'antd'
import moment from 'moment'
import styles from './masterDoc.less'
import _ from 'lodash'
import { RightsWrapper } from './utils'

const { TextArea } = Input
let Option = Select.Option

class StudentDocUtil extends Component {
    saveFiles = () => {
        this.setState({ uploading: true })
        let { fileDescription, fileName, files } = this.state
        let obj = {
            fileDescription, fileName, files, info: this.props.info,
        }

        Request.saveStudentDoc(obj)
            .then(resp => {
                if (resp.success) {
                    this.loadDocs()
                    this.setState({
                        fileDescription: '',
                        fileName: '',
                        //files: null,
                        files: [],
                        file: ''
                    })
                    this.onRemove()
                    return notification.success({
                        message: 'Success',
                        description: resp.msg
                    })
                }
                if (resp.error) {
                    return notification.error({ message: 'Error', description: resp.msg })
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    componentDidMount() {
        this.loadDocs();
        this.loadDocumentTitles()
    }

    handleDelete = (val) => {
        let obj = {
            id: this.props.info._id,
            mediaId: val
        }
        Request.deleteStudentMediaFiles(obj)
            .then(x => {
                if (x.success) {
                    this.loadDocs()
                    return notification.success({
                        message: x.msg
                    })

                } else {
                    return notification.error({ message: 'Error', description: x.msg })
                }
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }

    loadDocs = () => {
        let uploadedDocumentTypes = [];
        Request.studentMediaList({
            _id: this.props.info._id
        }).then(resp => {
            if (resp.success) {
                _.each(resp.arr, val => {
                    val.link = MEDIA_URL + val.file.url
                    val.date = val.file.date
                    uploadedDocumentTypes.push(val.fileName);
                })
                this.setState({ arr: resp.arr, uploadedDocumentTypes })
            }
        })
    }

    loadDocumentTitles = () => {
        Request.getDocumentTypeTitles({}).then((res) => {
            this.setState({ documentTitles: res })
        })
    }

    handleChange = v => {
        if (v.fileList) {
            this.setState({ files: v.fileList })
        }
    }

    onRemove = v => {
        console.log(v)
    }

    constructor(props) {
        super(props)
        this.state = {
            uploadedDocumentTypes: [],
            fileDescription: '',
            fileName: '',
            // files: null,
            files: [],
            arr: [],
            uploading: false,
            documentTitles: [],
        }
    }

    render() {
        const { uploading, uploadedDocumentTypes, documentTitles } = this.state;
        let documentTypes = [];
        documentTitles.map((documentTitle) => {
            // if(!uploadedDocumentTypes.includes(documentTitle)) {
            documentTypes.push(documentTitle);
            // }
        })
        return (
            <React.Fragment>
                <Row>
                    <Col span={12}>
                        <div className="gutter-example">
                            <Row gutter={16} className={styles['margin-t-md']}>
                                <Col className="gutter-row" span={6}>
                                    <div className="gutter-box">Name</div>
                                </Col>
                                <Col className="gutter-row" span={18}>
                                    <div className="gutter-box">
                                        <Select placeholder="Choose Document" showSearch={true} style={{ width: "100%" }} onChange={e => {
                                            this.setState({ fileName: e })
                                        }}>
                                            {

                                                documentTypes && documentTypes.map((document, index) => (
                                                    <Option key={index} value={document}>{document}</Option>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="gutter-example">
                            <Row gutter={16} className={styles['margin-t-md']}>
                                <Col className="gutter-row" span={6}>
                                    <div className="gutter-box">Description</div>
                                </Col>
                                <Col className="gutter-row" span={18}>
                                    <div className="gutter-box">
                                        <TextArea
                                            rows="5"
                                            placeholder="Description"
                                            value={this.state.fileDescription}
                                            onChange={e => {
                                                this.setState({ fileDescription: e.target.value })
                                            }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>

                        <div className="gutter-example">
                            <Row gutter={16} className={styles['margin-t-md']}>
                                <Col className="gutter-row" span={6}>
                                    <div className="gutter-box">File</div>
                                </Col>
                                <Col className="gutter-row" span={18}>
                                    <div className="gutter-box">
                                        <Upload
                                            // name={'file'}
                                            fileList={this.state.files}
                                            loading={uploading}
                                            action={`${LAPI_URL}/filesUploader`}
                                            onChange={this.handleChange}
                                            onRemove={this.onRemove}
                                            maxLimit={1}
                                        >
                                            <Button>
                                                <Icon type="upload" /> Select File
                                            </Button>
                                        </Upload>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="gutter-example">
                            <Row gutter={16} className={styles['margin-t-md']}>
                                <Col className="gutter-row" span={6} />
                                <Col className="gutter-row" span={6}>
                                    <Button type="primary" onClick={this.saveFiles}>
                                        Upload Now
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={12}>
                        <List
                            className={styles['demo-loadmore-list']}
                            size="small"
                            header={<div>Total : {this.state.arr.length}</div>}
                            bordered
                            dataSource={this.state.arr}
                            renderItem={item => (
                                <List.Item key={item.id}>
                                    <List.Item.Meta
                                        title={
                                            <a
                                                href={item.link}
                                                style={{
                                                    color: 'orange',
                                                    textDecorationLine: 'underline'
                                                }}
                                                target={'_blank'}>
                                                {item.fileName ? item.fileName : (item.title ? item.title : item.file.name)}
                                            </a>
                                        }
                                        description={
                                            <div style={{ fontSize: 13 }}>
                                                <small>{item.fileDescription}</small>
                                                <div>{item.date && `${moment(item.date).format('Do MMMM, YYYY')} [${moment(item.date).format('hh:mm A')}]`}</div>
                                                <div>{item.uploadedBy ? item.uploadedBy.name : ''}</div>
                                            </div>
                                        }
                                    />
                                    <div>
                                        <RightsWrapper myRight={"UploadDocuments.delete"}>
                                            <Tooltip title="Delete">
                                                <Popconfirm
                                                    title="Are you sure to delete?"
                                                    onConfirm={() => this.handleDelete(item.file._id)}>
                                                    <Button
                                                        style={{ marginLeft: '5px' }}
                                                        size={'small'}
                                                        shape="circle"
                                                        icon="delete" />
                                                </Popconfirm>
                                            </Tooltip>
                                        </RightsWrapper>
                                    </div>
                                </List.Item>

                            )}
                        />
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default StudentDocUtil
